import { link } from '@/components/core/components/atoms/link/link.styles';
import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  width: clamp(250px, auto, 90%);
  z-index: 10;
  gap: 0.5rem;
`;

export const toast = css`
  background-color: ${theme.colors.peoople['azul-claro-medio']};
  border-radius: 0.75rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  .${link} {
    color: white;
    text-decoration: underline;
  }
`;

export const close = css`
  cursor: pointer;
`;
